import Research from './Research'; 

export default Research;